import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-primary to-primary-dark rounded-xl overflow-hidden shadow-2xl">
          <div className="grid md:grid-cols-2 items-center">
            <div className="p-10 md:p-12 text-white">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <h2 className="text-3xl font-monomakh mb-6 leading-tight">Pronti a Iniziare il Tuo Viaggio Immobiliare?</h2>
                <p className="text-gray-200 mb-8 text-lg">
                  Che tu stia cercando la casa dei tuoi sogni o voglia vendere il tuo immobile, 
                  siamo qui per guidarti in ogni passo del percorso.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <Phone className="h-5 w-5 mr-3 text-secondary" />
                    <span>+39 327 8855115</span>
                  </div>
                  <div className="flex items-center">
                    <Mail className="h-5 w-5 mr-3 text-secondary" />
                    <span>info@molinaroimmobiliare.it</span>
                  </div>
                  <div className="flex items-center">
                    <MapPin className="h-5 w-5 mr-3 text-secondary" />
                    <span>Via Pisana 327, Scandicci 50018</span>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link 
                    to="/contatti"
                    className="bg-white text-primary hover:bg-gray-100 font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center"
                  >
                    Contattaci
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                  <Link 
                    to="/immobili"
                    className="bg-secondary hover:bg-secondary-light text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center"
                  >
                    Esplora gli Immobili
                  </Link>
                </div>
              </motion.div>
            </div>
            <div className="hidden md:block h-full">
              <img 
                src="/images/agenzia1.jpeg" 
                alt="Real estate consultation" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;